// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"index_mainHeading_3VBLs"};